import type { RouteLocationNormalized, Router } from "vue-router";

export const applicationRouteName = {
  index: "application.index",
  detail: "application.detail",
};

export const applicationRoute = [
  {
    path: "/applications",
    name: applicationRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "application",
      breadcrumbs: () => [{ title: "Application" }],
    },
  },
  {
    path: "/applications/:id",
    name: applicationRouteName.detail,
    component: () => import("../pages/DetailPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "application",
      breadcrumbs: (_to: RouteLocationNormalized, router: Router) => [{ path: router.resolve({ name: applicationRouteName.index }).path, title: "Application" }, { title: "Detail" }],
    },
  },
];
